import api from '@/lib/api'
import { getField, updateField } from 'vuex-map-fields'
import { PATH_EXPENSES_TYPES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const expensesTypes = {
  namespaced: true,
  state: buildInitialState({
    expensesTypesList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setExpensesTypes: (state, expensesTypes) => {
      state.expensesTypesList = expensesTypes
    }
  },
  actions: {
    getExpensesTypes ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_EXPENSES_TYPES, parameters: filters })
        .then(json => json.data)
        .then(expensesTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setExpensesTypes', expensesTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default expensesTypes
